import { SharedDirectivesModule } from './../../_directives/shared-directives.module';
import { NoResultModule } from './../_component/no-result/no-result.module';
import { TranslateModule } from '@ngx-translate/core';
import { SearchBarModule } from './../_component/search-bar/search-bar.module';
import { ItemCommunityModule } from './../community/item-community/item-community.module';
import { InfoPageModule } from './../info/info.module';
import { HeaderModule } from '../../_component/header/header.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { IntegrationTripPageRoutingModule } from './integration-trip-routing.module';

import { IntegrationTripPage } from './integration-trip.page';
import { IntegrationTripService } from './integration-trip.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    IntegrationTripPageRoutingModule,
    HeaderModule,
    InfoPageModule,
    ItemCommunityModule,
    SearchBarModule,
    TranslateModule,
    NoResultModule,
    SharedDirectivesModule
  ],
  declarations: [
    IntegrationTripPage
  ],
  providers: [
    IntegrationTripService
  ]
})
export class IntegrationTripPageModule {}
